import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Models
import { icon, title } from 'models/installation';
// Custom
import { installationDataShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';

const InstallationInformationItem = ({ installation, light }) => {
  if (installation) {
    return (
      <InformationItem
        light={light}
        icon={icon}
        label={<LocalizedMessage id="field.installation" />}
        value={title(installation)}
      />
    );
  }
  return (
    <InformationItem
      light={light}
      icon={icon}
      label=""
      value={<LocalizedMessage id="info.noInstallation" />}
    />
  );
};

InstallationInformationItem.propTypes = {
  installation: installationDataShape,
  light: PropTypes.bool,
};

InstallationInformationItem.defaultProps = {
  installation: null,
  light: false,
};

module.exports = InstallationInformationItem;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/main/InstallationInformationItem.js